import { render, staticRenderFns } from "./TransparencySpider.vue?vue&type=template&id=878b4008&scoped=true"
import script from "./TransparencySpider.vue?vue&type=script&lang=js"
export * from "./TransparencySpider.vue?vue&type=script&lang=js"
import style0 from "./TransparencySpider.vue?vue&type=style&index=0&id=878b4008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878b4008",
  null
  
)

export default component.exports